export default __webpack_public_path__ + "static/media/blockchain-execution.f5ec4f96.svg";